<script>
  import SubCategoryBadge from '../../components/AddClient/SubCategoryBadge.svelte';
  import ProfileImg from '../../components/ProfileImage.svelte';
  import { displayTimeAgo } from 'components/Helper.js';
  import ReadMore from '../../components/ReadMore/ReadMore.svelte';
  import ReadMoreHeight from 'components/ReadMore/ReadMoreHeight.svelte';
  export let itemData;

  let categoryArr = itemData.categories != null ? itemData.categories.split(',') : [];
  export let showDelete = () => {};
  export let showEdit = () => {};
</script>

<div class="d-flex flex-row client-notes border-bottom mb-2">
  <ProfileImg
    size={40}
    photoUrl={itemData.user.photoUrl}
    firstName={itemData.user.firstName}
    lastName={itemData.user.lastName}
    className="d-inline-block align-middle me-3"
  />

  <div class="w-100 ql-snow">
    <div class="d-flex flex-row justify-content-between mb-1 align-items-center">
      <span class="font-weight-500">{itemData.user.firstName} {itemData.user.lastName}</span>
      <div class="task-time d-flex flex-row align-items-center">
        <img
          class="me-1 icon-14"
          alt=""
          src="./images/clock.svg"
        />
        <small class="text-muted">{itemData.timeAgoStr}</small>
        {#if itemData.canEdit}
          <button
            class="btn bg-transparent shadow-none border-0 p-0 m-0 ms-2 color-blue font-size-12"
            on:click={() => showEdit(itemData.id)}
          >
            <img
              class=" icon-12"
              alt=""
              src="/images/pencil-gray.svg"
            />
          </button>
        {/if}
        {#if itemData.canDelete}
          <button
            class="btn bg-transparent shadow-none border-0 p-0 m-0 ms-2 color-blue font-size-12"
            on:click={() => showDelete(itemData.id)}
          >
            <img
              class=" icon-12"
              alt=""
              src="/images/cancel.svg"
            />
          </button>
        {/if}
      </div>
    </div>
    <div
      class="mb-2 pclassp ql-editor"
      style="padding:0 !important;"
    >
      <ReadMoreHeight
        maxHeight="200"
        label={itemData.notes != null ? itemData.notes : ''}
      />
    </div>
    {#if itemData.categories != ''}
      <div class="d-flex flex-row mb-2">
        {#each categoryArr as category}
          <SubCategoryBadge
            Style="mb-1 me-1"
            name={category}
          />
        {/each}
      </div>
    {/if}
  </div>
</div>

<style lang="scss">
  .client-notes {
    border-color: $input-border-color;
  }
</style>
